import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import { GetTask, getTasksLength, GetProblems } from '../../state-management';
import { Problem } from '../../models/problem';
import { of } from 'rxjs';

@Injectable()
export class WorkRequestGuard  {

  activityNo: string;
  problemNo: string;

  constructor(private store: Store<{}>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.activityNo = route.queryParams.ActivityNo;
    this.problemNo = route.queryParams.ProblemNo;
    this.store.dispatch(new GetTask({activityNo: this.activityNo}));
    this.store.dispatch(new GetProblems({ problemNo: this.problemNo }));
    return of(true);
  }
}
